import { Attributes, LookupBase, Misc, NeoModel } from '@singularsystems/neo-core';
import { PreferredCommunicationMethod } from '../Enums/PreferredCommunicationMethod';

@NeoModel
export default class ParticipantCommunicationPreferenceLookup extends LookupBase {

    /** The participant's own preferred communication method. Null means use org default. */
    @Attributes.Nullable()
    public preferredCommunicationMethod: PreferredCommunicationMethod | null = null;

    /** The tenant IdP default communication method. */
    @Attributes.Nullable()
    public tenantDefaultCommunicationMethod: PreferredCommunicationMethod | null = null;

    /** When the tenant IdP default was last updated. */
    @Attributes.Date(Misc.TimeZoneFormat.None)
    @Attributes.Nullable()
    public tenantDefaultLastUpdatedOn: Date | null = null;

    /** Whether the participant's mobile number has been verified. */
    public canSetSmsPreference: boolean = false;

    /** The effective communication method: user override if set, otherwise tenant default. */
    public get effectiveCommunicationMethod(): PreferredCommunicationMethod | null {
        return this.preferredCommunicationMethod ?? this.tenantDefaultCommunicationMethod;
    }

    // Client only properties / methods
}
